<template>
  <v-dialog v-model="intDialogVisible" max-width="600px" class="addValueModal addComment">
    <v-card>
      <v-card-title>
        <h3 class="primary--text formName">{{formName}}</h3>
      </v-card-title>
      <v-card-text>
        <v-form class="px-3"  @submit.prevent="submit">
          <input type="number" :min="minLicence" v-model="customerValue" class="addValueInput"/> licences

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="close" >
              Close
            </v-btn>
            <v-btn class="addValue" @click="submit" >
              Update
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
 import { toast } from 'vue-sonner'
export default {
  props: {
    dialogVisible: Boolean,
    formName: String,
    minLicence: Number,
    currentLicence: Number,
  },
  data () {
    return{
      customerValue:0,
      returnedCustomerValue:'',
    }
  },
  methods:{
    submit(){
      if(this.customerValue < this.minLicence){
        var torm = Math.abs(this.customerValue - this.minLicence);
        if(torm > 1){
          torm = torm+" accounts";
        }
        else{
          torm = torm+ " account";
        }
        toast.error("You can't allow "+this.customerValue+" licences. User has "+this.minLicence+" active account. Please remove "+torm+" before");
      }
      else{
        this.returnedCustomerValue = this.customerValue;
        this.customerValue = "";
         this.$emit('newValueIsProposed',this.returnedCustomerValue)
      }

    },
    close(){
        this.$emit('close',false)
    }
  },
  computed: {
    intDialogVisible: {
      get: function () {
        if (this.dialogVisible) {
          // Some dialog initialization code could be placed here
          // because it is called only when this.dialogVisible changes
        }

        return this.dialogVisible
      },
      set: function (value) {
             if (!value) {
                this.$emit('close', value);
             }
      }
    }
  },
  watch: {
    dialogVisible: function(){
      this.customerValue = this.currentLicence;
    }
  }

}
</script>

<style media="screen" scoped>
  .addValueModal .v-card{
    padding:10px;
  }
  .addValueModal .v-field__outline{
    display:none;
  }
  .formName{
    text-align: left;
    font-size: 21px;
    line-height: 25px;
    color: #3783C5;
  }
  .addValueModal button{
    border: 1px solid #3783C5;
    border-radius: 50px;
    opacity: 1;
    padding: 7px 18.5px;
    color:#3783C5;
    margin: 5px;
  }

    .addValueModal button.addValue{
      border: 1px solid #3783C5;

      background:#3783C5;
      color:#fff;
    }

    .addValueInput input{
      border: 1px solid #DDDDDD;
    }
  .addComment textarea{
    width: 100%;
margin: 0;
border: 1px solid #DDDDDD;
mask-image: none !important;
  }
  .v-card-title{
    white-space: normal !important;
  }
</style>
